import { compose, withProps, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import get from 'lodash/get';
import { URGENT_VISIT_TYPE_CODE } from '../../../constants';

import {
  selectConfirmVisitGWPending,
  selectConfirmVisitPending,
  selectConsentFormData,
  selectInlineVisitTimeSlots,
  selectInlineVisitTimeSlotsPending,
  selectProgramBasedVisitId,
  selectProgressInsuranceEligibilityId,
  selectProgressIsCreateFlowGW,
  selectProgressLocation,
  selectProgressOrganization,
  selectProgressRescheduleData,
  selectProgressSchedule,
  selectProgressScheduleId,
  selectProgressScheduleLocationId,
  selectProgressScheduleProvider,
  selectProgressService,
  selectProgressVisitType,
  selectProviderGWDetailsPending,
  selectReasonForOverview,
  selectSelfSchedulingConfirmPending,
  selectSuccessConfirmInlineVisit,
  selectCopayPrice,
  selectIsEirVisitTypeCode,
  selectCreateEirUrgentCareAppointmentPending,
  selectProgressCareUser,
  selectEirVisitTypePCPFormData,
  selectPreferredPharmacy,
  selectConsentFormPending,
  selectAdditionalInfoFormData,
  selectInsuranceEligibilityId,
} from '../../../redux/appointmentForm/selectors';
import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import * as confirmVisitSelfScheduling from '../../../redux/appointmentForm/requests/confirm-visit-selfScheduling-req';
import * as confirmVisitGW from '../../../redux/appointmentForm/requests/confirm-visit-GW-req';
import * as consent from '../../../redux/appointmentForm/requests/consent-req';
import * as inlineVisitTimeSlots from '../../../redux/appointmentForm/requests/inline-visits-time-slots';
import * as confirmInlineVisit from '../../../redux/appointmentForm/requests/confirm-inline-visit';
import * as fetchCopay from '../../../redux/appointmentForm/requests/fetch-copay';
import { actions as createEirUrgentCareAppointmentActions } from '../../../redux/appointmentForm/requests/create-eir-urgent-care-appointment';

import {
  selectActiveAppointmentId,
  selectUpcomingAppointmentList,
} from '../../../redux/healthboard/selectors';
import { selectShowPaperworkAppointmentQuestionStep } from '../../../redux/paperwork/selectors/paperwork-additional-info';

const mapStateToProps = state => ({
  careUser: selectProgressCareUser(state),
  consentsData: selectConsentFormData(state),
  createEirUrgentCareAppointmentPending: selectCreateEirUrgentCareAppointmentPending(
    state,
  ),
  fetchScheduleIdPending: selectProviderGWDetailsPending(state),
  insuranceEligibilityId:
    selectProgressInsuranceEligibilityId(state) ||
    selectInsuranceEligibilityId(state),
  isConfirmedInlineVisit: selectSuccessConfirmInlineVisit(state),
  isEirVisitType: selectIsEirVisitTypeCode(state),
  isGWFlow: selectProgressIsCreateFlowGW(state),
  loading: selectConfirmVisitPending(state),
  loadingGW: selectConfirmVisitGWPending(state),
  loadingTimeSlots: selectInlineVisitTimeSlotsPending(state),
  location: selectProgressLocation(state),
  locationId: selectProgressScheduleLocationId(state),
  organization: selectProgressOrganization(state),
  price: selectCopayPrice(state),
  pharmacyId: selectPreferredPharmacy(state),
  programBasedVisitId: selectProgramBasedVisitId(state),
  provider: selectProgressScheduleProvider(state),
  reason: selectReasonForOverview(state),
  rescheduleData: selectProgressRescheduleData(state),
  schedule: selectProgressSchedule(state),
  scheduleId: selectProgressScheduleId(state),
  selfScheduleConfirmPending: selectSelfSchedulingConfirmPending(state),
  service: selectProgressService(state),
  timeSlots: selectInlineVisitTimeSlots(state),
  visitType: selectProgressVisitType(state),
  pcpFormData: selectEirVisitTypePCPFormData(state),
  isConsentDataFetching: selectConsentFormPending(state),
  additionalInfoFormData:
    selectAdditionalInfoFormData(state) ||
    selectUpcomingAppointmentList(state).find(
      ({ id }) => id === selectActiveAppointmentId(state),
    ),
  showPaperworkAppointmentQuestionStep: selectShowPaperworkAppointmentQuestionStep(
    state,
  ),
});

const mapDispatchToProps = {
  clearProgressConsents: consent.actions.clear,
  confirmInlineVisit: confirmInlineVisit.actions.send,
  confirmVisit: confirmVisitSelfScheduling.actions.send,
  confirmVisitGW: confirmVisitGW.actions.send,
  createEirUrgentCareAppointment: createEirUrgentCareAppointmentActions.send,
  fetchConsent: consent.actions.send,
  fetchCopay: fetchCopay.actions.send,
  getAvailableTimeSlots: inlineVisitTimeSlots.actions.send,
  setScheduleData: appointmentProgressActions.setScheduleData,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ rescheduleData }) => ({
    isRescheduleFlow: !!get(rescheduleData, 'id', null),
  })),
  lifecycle({
    componentDidMount() {
      const {
        careUser,
        consentsData,
        fetchConsent,
        locationId,
        service,
        visitType,
      } = this.props;

      const isUrgentVirtualVisit = visitType.code === URGENT_VISIT_TYPE_CODE;

      if (!consentsData && !isUrgentVirtualVisit)
        fetchConsent({
          serviceId: service.id,
          locationId,
          visitTypeCode: visitType.code,
          userId: careUser.id,
        });
    },
  }),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentOverview/enhance.js